import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserNotAssignedToApplicationErrorPageComponent } from './user-not-assigned-to-application-error-page.component';
import { TranslationModule } from '../shared/translation/translation.module';

@NgModule({
  imports: [
    CommonModule,
    TranslationModule
  ],
  declarations: [UserNotAssignedToApplicationErrorPageComponent]
})
export class UserNotAssignedToApplicationErrorPageModule { }
